// @mui material components
import {
  Snackbar,
  Alert,
  Grid,
  Card,
  CircularProgress,
  Backdrop,
  Icon,
  Table,
  TableBody,
  TableRow,
  TableCell,
  Button,
  // Icon,
  // Dialog,
  // DialogActions,
  // DialogContent,
  // DialogTitle,
  // DialogContentText,
  // Tooltip,
} from "@mui/material";

// Material Dashboard 2 React components
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
// import MDInput from "theme/components/MDInput";
import VerticalBarChart from "examples/Charts/BarCharts/VerticalBarChart";
import PieChart from "examples/Charts/PieChart";

// Material Dashboard 2 React example components
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";

import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios.js";
// import DataTable from "theme/Tables/DataTable";
// import MDBadge from "theme/components/MDBadge";
// import MDButton from "theme/components/MDButton";
import usePageTitle from "app/pageTitle";
// import AppConfig from "appConfig";
// import { useAuthUser } from "react-auth-kit";

// import Editor from "react-simple-wysiwyg";

import GoogleMapReact from "google-map-react";
import MDButton from "components/MDButton";
import AppConfig from "appConfig";

function CampaignOverview() {
  const pageTitle = "Campaign Overview";
  usePageTitle(pageTitle);

  const { id } = useParams();
  const navigate = useNavigate();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  const [refreshPage, setRefreshPage] = useState(false);
  const [salesOverview, setSalesOverview] = useState({});
  const [currency, setCurrency] = useState({});
  const [breakdown, setBreakdown] = useState({});
  const [dataMetrics, setDataMetrics] = useState(null);
  const [productsMetrics, setProductsMetrics] = useState(null);
  const [paymentMethodMetrics, setPaymentMethodMetrics] = useState(null);
  const [successMetrics, setSuccessMetrics] = useState(null);
  const [velocityMetrics, setVelocityMetrics] = useState(null);
  const [groupMetrics, setGroupMetrics] = useState(null);
  const [supervisorMetrics, setSupervisorMetrics] = useState(null);
  const [locationPoints, setLocationPoints] = useState([]);
  const [mapZoom, setMapZoom] = useState(6);

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get(`/portal/campaigns/${id}/overview.json`)
        .then((result) => {
          setShowLoading(false);
          console.log(result.data);
          if (result.data.status === "success") {
            setCurrency(result.data.data.currency);
            setSalesOverview(result.data.data.overview);
            setBreakdown(result.data.data.overview.breakdown);
            setDataMetrics(result.data.data.dataMetrics);
            setProductsMetrics(result.data.data.productsMetrics);
            setPaymentMethodMetrics(result.data.data.paymentMethodMetrics);
            setSuccessMetrics(result.data.data.successMetrics);
            setVelocityMetrics(result.data.data.velocityMetrics);
            setLocationPoints(result.data.data.overview.locationPoints);
            setGroupMetrics(result.data.data.groupMetrics);
            setSupervisorMetrics(result.data.data.supervisorMetrics);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine ? "" : "Make sure you have an active internet connection"
            }`
          );
          setOpen(true);
        });
    };

    fetchData();
  }, [refreshPage]);

  function getPieChartColors(data) {
    const colors = ["info", "primary", "secondary", "error", "warning", "success"];
    const bgColors = [];
    data.every(() => {
      bgColors.push(colors[Math.floor(Math.random() * colors.length)]);
      return true;
    });

    return bgColors;
  }

  function getPieChartLabels(data) {
    const labels = [];
    data.every((row) => {
      labels.push(row.label);
      return true;
    });

    return labels;
  }

  function getPieChartData(data) {
    const datas = [];
    data.every((row) => {
      datas.push(row.count);
      return true;
    });

    return datas;
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      <MDBox pb={3}>
        <MDBox mt={3} mb={2} display="flex" justifyContent="space-between">
          <MDBox>
            <Button
              color="dark"
              size="small"
              startIcon={<Icon>west</Icon>}
              onClick={() => {
                navigate(`/campaigns`);
              }}
            >
              Campaigns
            </Button>
          </MDBox>
          <MDBox>
            <Button
              color="dark"
              size="small"
              onClick={() => setRefreshPage(!refreshPage)}
              startIcon={<Icon color="dark">sync</Icon>}
            >
              Refresh
            </Button>
            <Button
              color="dark"
              size="small"
              onClick={() => navigate(`/campaigns/${id}/sales`)}
              startIcon={<Icon color="dark">list</Icon>}
            >
              Sales
            </Button>
            <Button
              color="dark"
              size="small"
              onClick={() => navigate(`/campaigns/${id}/activity`)}
              startIcon={<Icon color="dark">troubleshoot</Icon>}
            >
              Activity Tracker
            </Button>
            <Button
              color="dark"
              size="small"
              onClick={() => navigate(`/campaigns/${id}/settings`)}
              startIcon={<Icon color="dark">settings</Icon>}
            >
              Manage
            </Button>
          </MDBox>
        </MDBox>
        <Grid container spacing={3}>
          <Grid item xs={12} md={12} lg={12}>
            <Card sx={{ height: "100%", marginTop: "0px" }}>
              <MDBox p={3}>
                <MDBox align="center">
                  <Icon color="success" fontSize="large">
                    bar_chart
                  </Icon>
                </MDBox>
                <MDBox mt={1}>
                  <MDBox align="center">
                    <MDTypography variant="h6" fontWeight="medium" fontSize="32px">
                      {currency.symbol}
                      {(
                        (salesOverview.salesVolume ? salesOverview.salesVolume : 0) / 100
                      ).toLocaleString("en", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </MDTypography>
                    <MDTypography variant="h6" fontWeight="light">
                      Total Volume
                    </MDTypography>
                  </MDBox>
                </MDBox>
                <MDBox mt={3}>
                  <Grid container spacing={3}>
                    <Grid item xs={12} md={4} lg={4}>
                      <MDBox
                        sx={{
                          height: "100%",
                          marginTop: "0px",
                          // display: "flex",
                          textAlign: {
                            xs: "center",
                            md: "start",
                            lg: "start",
                          },
                        }}
                      >
                        <MDTypography variant="h6" fontWeight="medium">
                          {(salesOverview.salesCount ? salesOverview.salesCount : 0).toLocaleString(
                            "en",
                            {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 0,
                            }
                          )}
                        </MDTypography>
                        <MDTypography variant="h6" fontWeight="light">
                          Total Sales
                        </MDTypography>
                      </MDBox>
                    </Grid>
                    <Grid item xs={12} md={4} lg={4}>
                      <MDBox align="center">
                        <MDTypography variant="h6" fontWeight="medium">
                          {currency.symbol}
                          {(
                            (salesOverview.todayVolume ? salesOverview.todayVolume : 0) / 100
                          ).toLocaleString("en", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </MDTypography>
                        <MDTypography variant="h6" fontWeight="light">
                          Today&apos;s Volume
                        </MDTypography>
                      </MDBox>
                    </Grid>
                    <Grid item xs={12} md={4} lg={4}>
                      <MDBox
                        sx={{
                          textAlign: {
                            xs: "center",
                            md: "end",
                            lg: "end",
                          },
                        }}
                      >
                        <MDTypography variant="h6" fontWeight="medium">
                          {(salesOverview.todayCount ? salesOverview.todayCount : 0).toLocaleString(
                            "en",
                            {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 0,
                            }
                          )}
                        </MDTypography>
                        <MDTypography variant="h6" fontWeight="light">
                          Today&apos;s Sales
                        </MDTypography>
                      </MDBox>
                    </Grid>
                  </Grid>
                </MDBox>
              </MDBox>
            </Card>
          </Grid>
          {/* <Grid item xs={12} md={5} lg={5}>
            <Card sx={{ height: "100%", marginTop: "0px" }}>
              <MDBox p={3} align="center">
                <MDBox>
                  <Icon color="dark" fontSize="large">
                    menu
                  </Icon>
                </MDBox>
                <MDBox mt={3}>
                  <MDButton
                    variant="outlined"
                    color="success"
                    size="small"
                    onClick={() => navigate(`/campaigns/${id}/sales`)}
                    startIcon={<Icon>list</Icon>}
                  >
                    Sales
                  </MDButton>
                </MDBox>
                <MDBox mt={3}>
                  <MDButton
                    variant="outlined"
                    color="warning"
                    size="small"
                    onClick={() => navigate(`/campaigns/${id}/agent-performance`)}
                    startIcon={<Icon>support_agent</Icon>}
                  >
                    Agent Stats
                  </MDButton>
                </MDBox>
                <MDBox mt={3}>
                  <MDButton
                    variant="outlined"
                    color="dark"
                    size="small"
                    onClick={() => navigate(`/campaigns/${id}/settings`)}
                    startIcon={<Icon>settings</Icon>}
                  >
                    Manage
                  </MDButton>
                </MDBox>
              </MDBox>
            </Card>
          </Grid> */}
        </Grid>
      </MDBox>
      {breakdown !== null && (
        <MDBox pt={3} pb={3}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6} lg={6}>
              <VerticalBarChart
                icon={{ color: "success", component: "leaderboard" }}
                title="Volume Trend"
                description="Daily Sales volume"
                chart={{
                  labels: breakdown.days,
                  datasets: [
                    {
                      label: "Volume",
                      color: "success",
                      data: breakdown.sum,
                    },
                  ],
                }}
              />
            </Grid>
            <Grid item xs={12} md={6} lg={6}>
              <VerticalBarChart
                icon={{ color: "info", component: "trending_up" }}
                title="Sales Trend"
                description="Daily Sales Count"
                chart={{
                  labels: breakdown.days,
                  datasets: [
                    {
                      label: "Sales",
                      color: "info",
                      data: breakdown.count,
                    },
                  ],
                }}
              />
            </Grid>
          </Grid>
        </MDBox>
      )}

      {successMetrics && (
        <MDBox mt={5}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6} lg={6}>
              <PieChart
                icon={{ color: "success", component: "done_all" }}
                title="Success Insights"
                description="Transaction completion rates"
                chart={{
                  labels: getPieChartLabels(successMetrics),
                  datasets: {
                    backgroundColors: getPieChartColors(successMetrics),
                    data: getPieChartData(successMetrics),
                  },
                }}
                height={200}
              />
            </Grid>
            <Grid item xs={12} md={6} lg={6}>
              <Card sx={{ height: "100%" }}>
                <MDBox p={2} sx={{ height: "100%" }}>
                  <Table sx={{ width: "100%" }} aria-label="simple table">
                    <TableBody>
                      <TableRow sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                        <TableCell>
                          <MDTypography variant="subtitle2" fontSize={14} fontWeight="bold">
                            Transaction Status
                          </MDTypography>
                        </TableCell>
                        <TableCell>
                          <MDTypography variant="subtitle2" fontSize={14} fontWeight="bold">
                            Count
                          </MDTypography>
                        </TableCell>
                      </TableRow>
                      {successMetrics.map((successMetric) => (
                        <TableRow sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                          <TableCell>
                            <MDTypography variant="subtitle2" fontSize={14}>
                              {successMetric.label}
                            </MDTypography>
                          </TableCell>
                          <TableCell>
                            <MDTypography variant="subtitle2" fontSize={14}>
                              {successMetric.count.toLocaleString("en", {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 0,
                              })}
                            </MDTypography>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </MDBox>
              </Card>
            </Grid>
          </Grid>
        </MDBox>
      )}

      {paymentMethodMetrics && (
        <MDBox mt={5}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={5} lg={5}>
              <PieChart
                icon={{ color: "secondary", component: "paid" }}
                title="Payment Method Insights"
                description="Distribution of preferred payment methods."
                chart={{
                  labels: getPieChartLabels(paymentMethodMetrics),
                  datasets: {
                    backgroundColors: getPieChartColors(paymentMethodMetrics),
                    data: getPieChartData(paymentMethodMetrics),
                  },
                }}
                height={150}
              />
            </Grid>
            <Grid item xs={12} md={7} lg={7}>
              <Card sx={{ height: "100%" }}>
                <MDBox p={2} sx={{ height: "100%" }}>
                  <Table sx={{ width: "100%" }} aria-label="simple table">
                    <TableBody>
                      <TableRow sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                        <TableCell>
                          <MDTypography variant="subtitle2" fontSize={14} fontWeight="bold">
                            Method
                          </MDTypography>
                        </TableCell>
                        <TableCell>
                          <MDTypography variant="subtitle2" fontSize={14} fontWeight="bold">
                            Count
                          </MDTypography>
                        </TableCell>
                        <TableCell>
                          <MDTypography variant="subtitle2" fontSize={14} fontWeight="bold">
                            Volume
                          </MDTypography>
                        </TableCell>
                      </TableRow>
                      {paymentMethodMetrics.map((product) => (
                        <TableRow sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                          <TableCell>
                            <MDTypography variant="subtitle2" fontSize={14}>
                              {product.label}
                            </MDTypography>
                          </TableCell>
                          <TableCell>
                            <MDTypography variant="subtitle2" fontSize={14}>
                              {product.count.toLocaleString("en", {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 0,
                              })}
                            </MDTypography>
                          </TableCell>
                          <TableCell>
                            <MDTypography variant="subtitle2" fontSize={14}>{`${currency.symbol}${(
                              product.volume / 100
                            ).toLocaleString("en", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}`}</MDTypography>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </MDBox>
              </Card>
            </Grid>
          </Grid>
        </MDBox>
      )}

      {velocityMetrics && (
        <MDBox mt={5}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={5} lg={5}>
              {/* <PieChart
                icon={{ color: "info", component: "electric_bolt" }}
                title="Velocity Insights"
                description="Average speed in minutes by payment method."
                chart={{
                  labels: getPieChartLabels(velocityMetrics),
                  datasets: {
                    backgroundColors: getPieChartColors(velocityMetrics),
                    data: getPieChartData(velocityMetrics),
                  },
                }}
                height={150}
              /> */}
              <VerticalBarChart
                icon={{ color: "warning", component: "electric_bolt" }}
                title="Velocity Insights"
                description="Average speed in minutes by payment method."
                chart={{
                  labels: getPieChartLabels(velocityMetrics),
                  datasets: [
                    {
                      label: "Speed",
                      color: "secondary",
                      data: getPieChartData(velocityMetrics),
                    },
                  ],
                }}
              />
            </Grid>
            <Grid item xs={12} md={7} lg={7}>
              <Card sx={{ height: "100%" }}>
                <MDBox p={2} sx={{ height: "100%" }}>
                  <Table sx={{ width: "100%" }} aria-label="simple table">
                    <TableBody>
                      <TableRow sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                        <TableCell>
                          <MDTypography variant="subtitle2" fontSize={14} fontWeight="bold">
                            Method
                          </MDTypography>
                        </TableCell>
                        <TableCell>
                          <MDTypography variant="subtitle2" fontSize={14} fontWeight="bold">
                            Longest
                          </MDTypography>
                        </TableCell>
                        <TableCell>
                          <MDTypography variant="subtitle2" fontSize={14} fontWeight="bold">
                            Shortest
                          </MDTypography>
                        </TableCell>
                        <TableCell>
                          <MDTypography variant="subtitle2" fontSize={14} fontWeight="bold">
                            Average
                          </MDTypography>
                        </TableCell>
                      </TableRow>
                      {velocityMetrics.map((velocityMetric) => (
                        <TableRow sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                          <TableCell>
                            <MDTypography variant="subtitle2" fontSize={14}>
                              {velocityMetric.label}
                            </MDTypography>
                          </TableCell>
                          <TableCell>
                            <MDTypography variant="subtitle2" fontSize={14}>
                              {`${velocityMetric.max.toLocaleString("en", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })} min`}
                            </MDTypography>
                          </TableCell>
                          <TableCell>
                            <MDTypography variant="subtitle2" fontSize={14}>
                              {`${velocityMetric.min.toLocaleString("en", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })} min`}
                            </MDTypography>
                          </TableCell>
                          <TableCell>
                            <MDTypography variant="subtitle2" fontSize={14}>
                              {`${velocityMetric.count.toLocaleString("en", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })} min`}
                            </MDTypography>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </MDBox>
              </Card>
            </Grid>
          </Grid>
        </MDBox>
      )}

      <MDBox mb={5}>
        {productsMetrics && (
          <MDBox mt={7}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={4} lg={4}>
                <PieChart
                  icon={{ color: "secondary", component: "inventory_2" }}
                  title="Product Performance"
                  description="Product distribution across sales."
                  chart={{
                    labels: getPieChartLabels(productsMetrics),
                    datasets: {
                      backgroundColors: getPieChartColors(productsMetrics),
                      data: getPieChartData(productsMetrics),
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12} md={8} lg={8}>
                <Card sx={{ height: "100%" }}>
                  <MDBox p={2}>
                    <Table sx={{ width: "100%" }} aria-label="simple table">
                      <TableBody>
                        <TableRow sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                          <TableCell>
                            <MDTypography variant="subtitle2" fontSize={14} fontWeight="bold">
                              Product
                            </MDTypography>
                          </TableCell>
                          <TableCell>
                            <MDTypography variant="subtitle2" fontSize={14} fontWeight="bold">
                              Count
                            </MDTypography>
                          </TableCell>
                          <TableCell>
                            <MDTypography variant="subtitle2" fontSize={14} fontWeight="bold">
                              Volume
                            </MDTypography>
                          </TableCell>
                        </TableRow>
                        {productsMetrics.map((product) => (
                          <TableRow sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                            <TableCell>
                              <MDTypography variant="subtitle2" fontSize={14}>
                                {product.label}
                              </MDTypography>
                            </TableCell>
                            <TableCell>
                              <MDTypography variant="subtitle2" fontSize={14}>
                                {product.count.toLocaleString("en", {
                                  minimumFractionDigits: 0,
                                  maximumFractionDigits: 0,
                                })}
                              </MDTypography>
                            </TableCell>
                            <TableCell>
                              <MDTypography variant="subtitle2" fontSize={14}>{`${
                                currency.symbol
                              }${(product.volume / 100).toLocaleString("en", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}`}</MDTypography>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </MDBox>
                </Card>
              </Grid>
            </Grid>
          </MDBox>
        )}

        {groupMetrics && (
          <MDBox mt={5}>
            <PieChart
              sx={{ height: "100%", marginTop: "0px" }}
              // icon={{ color: "info", component: "leaderboard" }}
              title="Team Performance"
              description=""
              chart={{
                labels: getPieChartLabels(groupMetrics),
                datasets: {
                  label: "Team Performance LBL",
                  backgroundColors: getPieChartColors(groupMetrics),
                  data: getPieChartData(groupMetrics),
                },
              }}
            />
          </MDBox>
        )}

        {supervisorMetrics && (
          <MDBox mt={3}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6} lg={6}>
                <PieChart
                  sx={{ height: "100%", marginTop: "0px" }}
                  // icon={{ color: "info", component: "leaderboard" }}
                  title="Supervisor Performance (Count)"
                  description=""
                  chart={{
                    labels: getPieChartLabels(supervisorMetrics.count),
                    datasets: {
                      label: "Supervisor Performance",
                      backgroundColors: getPieChartColors(supervisorMetrics.count),
                      data: getPieChartData(supervisorMetrics.count),
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12} md={6} lg={6}>
                <PieChart
                  sx={{ height: "100%", marginTop: "0px" }}
                  // icon={{ color: "info", component: "leaderboard" }}
                  title="Supervisor Performance (Volume)"
                  description=""
                  chart={{
                    labels: getPieChartLabels(supervisorMetrics.vol),
                    datasets: {
                      label: "Supervisor Performance",
                      backgroundColors: getPieChartColors(supervisorMetrics.vol),
                      data: getPieChartData(supervisorMetrics.vol),
                    },
                  }}
                />
              </Grid>
            </Grid>
          </MDBox>
        )}

        {locationPoints.length > 0 && (
          <MDBox mt={5}>
            <Card>
              <MDBox p={3}>
                <MDBox mb={3} display="flex" justifyContent="space-between">
                  <MDBox>
                    <MDTypography variant="h6" fontWeight="bold">
                      Location HeatMap
                    </MDTypography>
                  </MDBox>
                  <MDBox>
                    <MDButton
                      size="small"
                      variant="outlined"
                      color="dark"
                      iconOnly
                      onClick={() => {
                        let pZoom = mapZoom;
                        pZoom -= 1;
                        pZoom = pZoom < 4 ? 4 : pZoom;
                        setMapZoom(pZoom);
                      }}
                    >
                      <Icon>remove</Icon>
                    </MDButton>
                    &nbsp;
                    <MDTypography variant="caption" fontSize={10} fontWeight="light">
                      Zoom
                    </MDTypography>
                    &nbsp;
                    <MDButton
                      size="small"
                      variant="outlined"
                      color="dark"
                      iconOnly
                      onClick={() => {
                        let pZoom = mapZoom;
                        pZoom += 1;
                        pZoom = pZoom > 20 ? 20 : pZoom;
                        setMapZoom(pZoom);
                      }}
                    >
                      <Icon>add</Icon>
                    </MDButton>
                  </MDBox>
                </MDBox>
                <MDBox sx={{ height: "65vh", width: "100%" }}>
                  <GoogleMapReact
                    bootstrapURLKeys={{ key: AppConfig.google_map_key }}
                    defaultCenter={{
                      lat: locationPoints[0].lat, // 9.084576,
                      lng: locationPoints[0].lng, // 8.674252,
                    }}
                    defaultZoom={mapZoom}
                    zoom={mapZoom}
                  >
                    {locationPoints.map((loc) => (
                      // <AnyReactComponent
                      //   cRef={loc.reference}
                      //   lat={loc.lat}
                      //   lng={loc.lng}
                      //   text="My Marker"
                      // />
                      <MDBox
                        lat={loc.lat}
                        lng={loc.lng}
                        onClick={() => navigate(`/campaigns-orders/${loc.reference}`)}
                      >
                        <MDTypography fontSize={24}>
                          <Icon color="error">location_on</Icon>
                        </MDTypography>
                      </MDBox>
                    ))}
                  </GoogleMapReact>
                </MDBox>
              </MDBox>
            </Card>
          </MDBox>
        )}

        {dataMetrics && (
          <MDBox mt={5} mb={5}>
            <MDBox align="center">
              <MDTypography fontSize={16}>Data Capture Insights</MDTypography>
            </MDBox>
            {dataMetrics.averageData && (
              <>
                {dataMetrics.averageData.map((item) => (
                  <MDBox mt={4}>
                    <Card>
                      <MDBox p={3}>
                        <MDBox mb={3} display="flex" justifyContent="space-between">
                          <MDBox>
                            <MDTypography variant="h6" fontWeight="bold">
                              {item.title}
                            </MDTypography>
                            <MDTypography variant="h6" fontWeight="light" fontSize={14}>
                              {item.section}
                            </MDTypography>
                          </MDBox>
                        </MDBox>
                        <MDBox>
                          <Grid container spacing={3}>
                            <Grid item xs={6} md={3} lg={3}>
                              <MDBox align="center">
                                <MDBox>
                                  <MDTypography variant="h6" fontWeight="bold" fontSize={24}>
                                    {item.figures.sum.toLocaleString("en", {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    })}
                                  </MDTypography>
                                </MDBox>
                                <MDBox>
                                  <MDTypography variant="h6" fontWeight="light">
                                    Sum
                                  </MDTypography>
                                </MDBox>
                              </MDBox>
                            </Grid>
                            <Grid item xs={6} md={3} lg={3}>
                              <MDBox align="center">
                                <MDBox>
                                  <MDTypography variant="h6" fontWeight="bold" fontSize={24}>
                                    {item.figures.avg.toLocaleString("en", {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    })}
                                  </MDTypography>
                                </MDBox>
                                <MDBox>
                                  <MDTypography variant="h6" fontWeight="light">
                                    Average
                                  </MDTypography>
                                </MDBox>
                              </MDBox>
                            </Grid>
                            <Grid item xs={6} md={3} lg={3}>
                              <MDBox align="center">
                                <MDBox>
                                  <MDTypography variant="h6" fontWeight="bold" fontSize={24}>
                                    {item.figures.max.toLocaleString("en", {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    })}
                                  </MDTypography>
                                </MDBox>
                                <MDBox>
                                  <MDTypography variant="h6" fontWeight="light">
                                    Maximum
                                  </MDTypography>
                                </MDBox>
                              </MDBox>
                            </Grid>
                            <Grid item xs={6} md={3} lg={3}>
                              <MDBox align="center">
                                <MDBox>
                                  <MDTypography variant="h6" fontWeight="bold" fontSize={24}>
                                    {item.figures.min.toLocaleString("en", {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    })}
                                  </MDTypography>
                                </MDBox>
                                <MDBox>
                                  <MDTypography variant="h6" fontWeight="light">
                                    Minimum
                                  </MDTypography>
                                </MDBox>
                              </MDBox>
                            </Grid>
                          </Grid>
                        </MDBox>
                      </MDBox>
                    </Card>
                  </MDBox>
                ))}
              </>
            )}
            {dataMetrics.chartData && (
              <MDBox mt={5}>
                <MDBox align="center">
                  <MDTypography fontSize={16}>Data Capture Insights</MDTypography>
                </MDBox>
                <MDBox mt={4}>
                  <Grid container spacing={3}>
                    {dataMetrics.chartData.map((metric) => (
                      <Grid item xs={12} md={6} lg={6}>
                        <MDBox mb={0}>
                          <PieChart
                            // icon={{ color: "info", component: "leaderboard" }}
                            title={metric.field.title}
                            description={metric.field.section}
                            chart={{
                              labels: getPieChartLabels(metric.metrics),
                              datasets: {
                                label: "Data Capture Insights",
                                backgroundColors: getPieChartColors(metric.metrics),
                                data: getPieChartData(metric.metrics),
                              },
                            }}
                          />
                        </MDBox>
                      </Grid>
                    ))}
                  </Grid>
                </MDBox>
              </MDBox>
            )}
            {dataMetrics.spreadData && (
              <>
                {dataMetrics.spreadData.map((item) => (
                  <MDBox mt={5}>
                    <Card>
                      <MDBox p={3}>
                        <MDBox mb={3} display="flex" justifyContent="space-between">
                          <MDBox>
                            <MDTypography variant="h6" fontWeight="bold">
                              {item.title}
                            </MDTypography>
                          </MDBox>
                        </MDBox>
                        <MDBox sx={{ height: "57vh", width: "100%" }}>
                          <GoogleMapReact
                            bootstrapURLKeys={{ key: AppConfig.google_map_key }}
                            defaultCenter={{
                              lat: item.coords[0].lat, // 9.084576,
                              lng: item.coords[0].lng, // 8.674252,
                            }}
                            defaultZoom={mapZoom}
                            zoom={mapZoom}
                          >
                            {item.coords.map((loc) => (
                              <MDBox lat={loc.lat} lng={loc.lng}>
                                <MDTypography fontSize={24}>
                                  <Icon color="error">location_on</Icon>
                                </MDTypography>
                              </MDBox>
                            ))}
                          </GoogleMapReact>
                        </MDBox>
                      </MDBox>
                    </Card>
                  </MDBox>
                ))}
              </>
            )}
          </MDBox>
        )}
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default CampaignOverview;
